export const API_URL = "https://apiprod.bookzy.app";

// LOCAL DEV URL
export const API_URL_1 = "http://63.34.147.105:5000";

// DEV URL
// export const API_URL_1 = "https://bmcapi-dev.bookzy.app/dev";

export const defaultServerImage = "https://bmcapp.s3.eu-west-1.amazonaws.com/assets/DefaultAvatar.png";
export const S3_BUCKET_NAME = "bmcapp";
export const S3_ACCESS_KEY_ID = "AKIA5EIADQFZC72DHT6P";
export const S3_SECRET_ACCESS_KEY = "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";
export const S3_REGION = "eu-west-1";
export const GOOGLE_MAPS_API = "AIzaSyBoaBW9HXkaHd0cJpIMev52Ek__wJgHH90";
export const defaultAvailablePaymentMethods = {
     "payAtVenue": {
          "enable": false,
          "processingFeeApplicable": true,
          "reserveNowPaylater": true,
          "paymentGatewayServiceFee": {
               "paymentProcessingFlatFee": 0,
               "paymentProcessingPercentage": 0
          }
     },
     "tikkie": {
          "enable": true,
          "allowAccess": false,
          "processingFeeApplicable": true,
          "paymentGatewayServiceFee": {
               "paymentProcessingFlatFee": 0,
               "paymentProcessingPercentage": 0
          }
     },
     "ideal": {
          "enable": false,
          "processingFeeApplicable": true,
          "paymentGatewayServiceFee": {
               "paymentProcessingFlatFee": 1,
               "paymentProcessingPercentage": 0
          }
     },
     "applePay": {
          "enable": true,
          "processingFeeApplicable": true,
          "paymentGatewayServiceFee": {
               "paymentProcessingFlatFee": 0.3,
               "paymentProcessingPercentage": 2.5
          }
     },
     "googlePay": {
          "enable": true,
          "processingFeeApplicable": true,
          "paymentGatewayServiceFee": {
               "paymentProcessingFlatFee": 0.3,
               "paymentProcessingPercentage": 2.5
          }
     },
     "creditCard": {
          "enable": true,
          "processingFeeApplicable": true,
          "paymentGatewayServiceFee": {
               "paymentProcessingFlatFee": 0.3,
               "paymentProcessingPercentage": 2.5
          }
     },
     "bookzyPlatformFee": {
          "enable": true,
          "processingFeeApplicable": true,
          "flatFee": 1,
          "percentageFee": 0
     }
}

export const displayAvailablePaymentMethods = {
     "NA": "NA",
     "Not Applicable": "Not Applicable",
     "payAtVenue": "Pay At Venue",
     "tikkie": "Tikkie",
     "ideal": "Ideal",
     "applePay": "Apple Pay",
     "googlePay": "Google Pay",
     "creditCard": "Credit Card",
     "bookzyPlatformFee": "bookzyPlatformFee",
     "classPass": "Not Applicable",
     "eventPass": "Event Pass",
     "servicePass": "Service Pass",
     "Cash": "Cash",
}
export const bookingStatusFilter = [
     { value: "all", title: "All" },
     { value: "confirmed", title: "Confirmed" },
     { value: "cancelled", title: "Cancelled" },
     { value: "refunded", title: "Refunded" },
]

export const statusColors = {
     "draft": { //draft
          borderWidth: 0,
          borderColor: "#D7BB294D",
          color: "#8C780C",
          backgroundColor: "#D7BB294D"
     },
     "false": { //draft
          borderWidth: 0,
          borderColor: "#D7BB294D",
          color: "#8C780C",
          backgroundColor: "#D7BB294D"
     },
     "trialing": { //draft
          borderWidth: 0,
          borderColor: "#D7BB294D",
          color: "#8C780C",
          backgroundColor: "#D7BB294D"
     },
     "published": { //published
          borderWidth: 0,
          borderColor: "#468C111F",
          color: "#468C11",
          backgroundColor: "#468C111F" //#468C111F
     },
     "true": { //published
          borderWidth: 0,
          borderColor: "#468C111F",
          color: "#468C11",
          backgroundColor: "#468C111F" //#468C111F
     },
     "active": { //published
          borderWidth: 0,
          borderColor: "#468C111F",
          color: "#468C11",
          backgroundColor: "#468C111F" //#468C111F
     },
     "cancelled": {
          borderWidth: 0,
          borderColor: "#ff404033",
          color: "#FF4040",
          backgroundColor: "#ff404033" // #ff404033
     },
     "canceled": {
          borderWidth: 0,
          borderColor: "#ff404033",
          color: "#FF4040",
          backgroundColor: "#ff404033" // #ff404033
     },
     "refunded": {
          borderWidth: 0,
          borderColor: "#ff404033",
          color: "#FF4040",
          backgroundColor: "#ff404033"
     }
};

export const classTypes = [
     { value: "", title: "Select Class Type..." },
     // Keep existing values (Yoga, Body Pump, Boot Camp, Fitness, General Fitness, Running, Biking): classes already use them.
     { value: "Aerobics", title: "Aerobics" },
     { value: "Aqua Fitness", title: "Aqua Fitness" },
     { value: "Barre", title: "Barre" },
     { value: "Biking", title: "Biking" },
     { value: "Body Pump", title: "Body Pump" },
     { value: "Boot Camp", title: "Boot Camp" },
     { value: "Boxing", title: "Boxing" },
     { value: "Circuit Training", title: "Circuit Training" },
     { value: "Core & Abs", title: "Core & Abs" },
     { value: "CrossFit", title: "CrossFit" },
     { value: "Dance", title: "Dance" },
     { value: "Fitness", title: "Fitness" },
     { value: "Functional Training", title: "Functional Training" },
     { value: "General Fitness", title: "General Fitness" },
     { value: "HIIT", title: "HIIT" },
     { value: "Indoor Cycling", title: "Indoor Cycling" },
     { value: "Kettlebell", title: "Kettlebell" },
     { value: "Kickboxing", title: "Kickboxing" },
     { value: "Kids Fitness", title: "Kids Fitness" },
     { value: "Martial Arts", title: "Martial Arts" },
     { value: "Meditation", title: "Meditation" },
     { value: "Mobility & Stretching", title: "Mobility & Stretching" },
     { value: "Pilates", title: "Pilates" },
     { value: "Running", title: "Running" },
     { value: "Senior Fitness", title: "Senior Fitness" },
     { value: "Strength Training", title: "Strength Training" },
     { value: "Yoga", title: "Yoga" },
     { value: "Zumba", title: "Zumba" },
];
export const billingPeriod = [
     { value: "day", title: "Daily", data: { interval: "day", interval_count: 1 } },
     { value: "week", title: "Weekly", data: { interval: "week", interval_count: 1 } },
     { value: "month", title: "Monthly", data: { interval: "month", interval_count: 1 } },
     { value: "year", title: "Yearly", data: { interval: "year", interval_count: 1 } },
     // { value: "3month", title: "Every 3 months", data: { interval: "month", interval_count: 3} },
     // { value: "6month", title: "Every 6 months", data: { interval: "month", interval_count: 6} },
]

export const creditsRenewalCycle = [
     { value: "day", title: "Every Daily", data: { interval: "day", interval_count: 1 } },
     { value: "week", title: "Every Weekly", data: { interval: "week", interval_count: 1 } },
     { value: "month", title: "Every Monthly", data: { interval: "month", interval_count: 1 } },
]

export const ignoreDomainList = [""]
export const defaultDomainList = ["", "localhost", "www", "sandbox", "business", "webapp"]
